/*
  Project: Dinizitig
  Author: Webwirkung
 */

import menu from './modules/menu';
import animation from './modules/animation';
import carousel from './modules/carousel';
import 'lazysizes';

menu();
animation();
carousel();



// WEBPACK FOOTER //
// ./src/scripts/app.js